<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
				<h5>Menu</h5>
                <hr>
                <TabView>
                    <TabPanel header="Lista">
                        <ListaMenu />
                    </TabPanel>
                    <TabPanel header="Publicação">
                        <PublicacaoMenu />
                    </TabPanel>
                </TabView>
            </div>            
        </div>        
    </div>  
</template>

<script>
import ListaMenu from '@/components/pages/cadastro/menu/Lista.vue';
import PublicacaoMenu from '@/components/pages/cadastro/menu/Publicacao.vue';
export default {    
    components: {
		'ListaMenu': ListaMenu,
        'PublicacaoMenu': PublicacaoMenu,		
    }
}
</script>

<style>
</style>